import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faBookOpen, faShareAlt, faHistory } from '@fortawesome/free-solid-svg-icons';

import useLangParam from '../hooks/useLangParam';
import LessonModel from '../models/LessonModel';
import ActivitiesIcon from '../components/icons/Activities';
import ApplicationIcon from '../components/icons/Application';
import SectionBlocks from '../components/lessonBlocks/SectionBlocks';
import SectionHeading from '../components/lessonBlocks/SectionHeading';
import Layout from './Layout';
import Loader from '../components/Loader';
import Done from '../components/Done';
import NotFound from '../components/NotFound';
import NetworkError from '../components/NetworkError';
import Header from "../components/Header.jsx";

function Lesson() {
  useLangParam();
  const { t } = useTranslation();

  const {
    id,
    lesson,
    answers,
    isLoading,
    isError,
    refetch,
  } = LessonModel();

  if (isError) {
    return (
      <Layout>
        <NetworkError onRefresh={refetch} />
      </Layout>
    );
  }

  if (isLoading) {
    return (
      <Layout>
        <Loader />
      </Layout>
    )
  }

  if (!lesson) {
    return (
      <Layout>
        <NotFound />
      </Layout>
    );
  }

  return (
    <Layout>
      <Header title={lesson.name} subtitle={lesson.subtitle} />
      <div className="lesson-section">
        <SectionHeading
          icon={<FontAwesomeIcon icon={faList} />}
          title={t('lesson.lessonObjectives')}
          blocks={lesson.blocksData.objectives}
        />
        <SectionBlocks blocks={lesson.blocksData.objectives} />
      </div>

      <div className="lesson-section">
        <SectionHeading
          icon={<FontAwesomeIcon icon={faHistory} />}
          title={t('lesson.recap')}
          blocks={lesson.blocksData.recap}
        />
        <SectionBlocks blocks={lesson.blocksData.recap} />
      </div>

      <div className="lesson-section">
        <SectionHeading
          icon={<FontAwesomeIcon icon={faBookOpen} />}
          title={t('lesson.scriptureReading')}
          blocks={lesson.blocksData.scripture}
        />
        <SectionBlocks blocks={lesson.blocksData.scripture} lessonId={id} answers={answers} />
      </div>

      <div className="lesson-section">
        <SectionHeading
          icon={<ActivitiesIcon className="icon-svg" />}
          title={t('lesson.optionalActivities')}
          blocks={lesson.blocksData.activities}
        />

        <SectionBlocks blocks={lesson.blocksData.activities} />
      </div>

      <div className="lesson-section">
        <SectionHeading
          icon={<ApplicationIcon className="icon-svg" />}
          title={t('lesson.applications')}
          blocks={lesson.blocksData.application}
        />

        <SectionBlocks blocks={lesson.blocksData.application} lessonId={id} />
      </div>

      <div className="lesson-section">
        <SectionHeading
          icon={<FontAwesomeIcon icon={faShareAlt} />}
          title={t('lesson.sharing')}
          blocks={lesson.blocksData.sharing}
        />

        <SectionBlocks blocks={lesson.blocksData.sharing} lessonId={id} />
      </div>

      <Done data={lesson} />
    </Layout>
  );
}
export default Lesson;
